import { $authHost } from "./index";

export const getSingers = async () => {
  const { data } = await $authHost.get("/api/singers");

  return data;
};

export const getSinger = async (id) => {
  const { data } = await $authHost.get(`/api/singers/${id}`);

  return data;
};

export const updateSinger = async (id, body) => {
  const { data } = await $authHost.put(`/api/singers/${id}`, body);

  return data;
};

export const createSinger = async (body) => {
  const { data } = await $authHost.post("/api/singers", body);

  return data;
};
